import { Component, Input, inject } from '@angular/core';
import { OtherAccountsService } from '../../../services/other-accounts/other-accounts.service';
import { ZciOverflowMenuService } from '../../../services/zci-overflow-menu/zci-overflow-menu.service';

import { ContentUtil } from '../../../utils/content/content.util';
import { ObservableAccountTileInputDataProps } from '../../../utils/sort/sort.service';
import { MapAccountTypePipe } from '../../../pipes/map-account-type/map-account-type.pipe';
import { MapRoleTypePipe } from '../../../pipes/role-type/map-role-type.pipe';
import { TileComponent } from '../tile.component';

@Component({
    selector: 'zci-observable-account-tile',
    templateUrl: './observable-account-tile.component.html',
    imports: [
        TileComponent,
        MapAccountTypePipe,
        MapRoleTypePipe,
    ],
})
export class ObservableAccountTileComponent implements ObservableAccountTileInputDataProps {
    private readonly navOverflowItemsService = inject(ZciOverflowMenuService);
    private readonly otherAccountsService = inject(OtherAccountsService);

    content = ContentUtil.content;

    zciOverflowItems = this.navOverflowItemsService.zciOverflowItems;

    @Input() accName: string;

    @Input() accType: string;

    @Input() roleType: string;

    navOverflowMenuConfig = this.otherAccountsService.getNavOverflowMenu();
}
